import React, { useState, useEffect } from 'react'
import './FlightPopup.css'
import axios from 'axios'
import { SpinnerLoading } from '../../../../components'

import infoIcon from "../../../../assets/images/flights/fluent_info-24-regular.svg"
import ticketIcon from "../../../../assets/images/flights/heroicons_ticket.svg"
import takeoffIcon from "../../../../assets/images/flights/take.svg"
import dropIcon from "../../../../assets/images/flights/drop.svg"
import timeIcon from "../../../../assets/images/flights/formkit_time.svg"
import handIcon from "../../../../assets/images/flights/fluent_money-hand-16-regular.svg"
import FlightPopupCard from '../FlightPopupCard/FlightPopupCard'

import { Splide, SplideSlide } from "@splidejs/react-splide";

const FlightPopup = ({ url, offer, onContinue }) => {
    const [loading, setLoading] = useState(false);
    const [bundleLoading, setBundleLoading] = useState(false);
    const [fareData, setFareData] = useState(null);
    const [bundleData, setBundleData] = useState(null);
    const [error, setError] = useState(null);
    const [bundleError, setBundleError] = useState(null);
    const [journeysData, setJourneysData] = useState([])
    const [priceRuleData, setPriceRuleData] = useState([])
    const [priceData, setPriceData] = useState(null)
    const [baggageData, setBaggageData] = useState([])
    const [offerData, setOfferData] = useState(null)

    const [selected, setSelected] = useState("Light");

    const fetchFareData = async () => {
        if (!offer) return;

        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(
                `${url}/api/method/alltimes.www.flight_api.fare`,
                {
                    offer: offer?.offerId,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            setOfferData(response?.data?.result?.selectedOfferOptions[0]);

        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch fare data');
            console.error('Error fetching fare data:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchBundleData = async (offerId) => {
        if (!offerId) return;

        setBundleLoading(true);
        setBundleError(null);

        try {
            const response = await axios.post(
                `${url}/api/method/alltimes.www.flight_api.bundle`,
                {
                    offer: offerId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            setBundleData(response?.data?.result?.bundleChoices);
            console.log('Bundle data:', response?.data?.result?.bundleChoices);

        } catch (err) {
            setBundleError(err.response?.data?.message || 'Failed to fetch bundle data');
            console.error('Error fetching bundle data:', err);
        } finally {
            setBundleLoading(false);
        }
    };

    // Call the fare API when component mounts
    useEffect(() => {
        if (offer) {
            fetchFareData();
        }
    }, [offer]);

    // Call the bundle API when offerData is available
    useEffect(() => {
        if (offerData?.offerId) {
            fetchBundleData(offerData.offerId);
        }
    }, [offerData?.offerId]);

    useEffect(() => {
        setPriceData(offerData?.priceDetails);
        setJourneysData(offerData?.details)
        setBaggageData(offerData?.baggage_details)
        setPriceRuleData(offerData?.price_rule_details)
    }, [offerData]);

     const handleContinue = () => {
       
        const continueData = {
            offerData: offerData,
            selectedBundle: selected,
            priceData: priceData,
            journeysData: journeysData,
            baggageData: baggageData,
            bundleData: bundleData
        };
        
        if (onContinue) {
            onContinue(continueData);
        }
    };

    if (!offer) return null;

    return (
        <div className="flight-popup">
            {
                loading ? (
                    <div className="flight-popup-loading-container">
                        <SpinnerLoading />
                    </div>
                ) : (
                    <>
                        <div className='flight-popup-first-section'>

                            <div className='flight-popup-categories'>
                                {/* Show bundle category only if bundle data exists or is loading */}
                                {(bundleLoading || bundleData) && (
                                    <div className='flight-popup-category'>
                                        <img src={ticketIcon} />
                                        <div>Have bundles</div>
                                    </div>
                                )}
                                {
                                    offerData?.canBeHeld && (
                                        <div className='flight-popup-category'>
                                            <img src={timeIcon} />
                                            <div>Can Hold</div>
                                        </div>
                                    )
                                }

                                {
                                    offerData?.refundability != "UnKnown" && (
                                        <div className='flight-popup-category'>
                                            <img src={handIcon} />
                                            <div>Refundable</div>
                                        </div>
                                    )
                                }
                            </div>

                            <div className='flight-popup-header'>
                                <div className='flight-popup-details-conatiner'>
                                    {
                                        journeysData?.map((item, index) => {
                                            // Parse departure date and time
                                            const departureDate = new Date(item.departureDateTime);
                                            const arrivalDate = new Date(item.arrivalDateTime);

                                            // Format time as HH:MM
                                            const formatTime = (date) => {
                                                return date.toLocaleTimeString('en-US', {
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    hour12: false
                                                });
                                            };

                                            // Format date as "MMM D, YYYY"
                                            const formatDate = (date) => {
                                                return date.toLocaleDateString('en-US', {
                                                    year: 'numeric',
                                                    month: 'short',
                                                    day: 'numeric'
                                                });
                                            };

                                            // Calculate duration
                                            const formatDuration = (minutes) => {
                                                const hours = Math.floor(minutes / 60);
                                                const mins = minutes % 60;
                                                return `${hours}H ${mins}Min`;
                                            };

                                            return (
                                                <>
                                                    <div className='flight-popup-details'>
                                                        <div className='flight-popup-departure'>
                                                            <div className='flight-popup-details-header'>{item.origin} <span>{item.departureTerminal}</span></div>
                                                            <div className='flight-popup-details-time-container'>
                                                                <div className='flight-popup-details-time-icon'>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                                                        <path d="M0.667011 6.00006L6.00034 0.666731M6.00034 0.666731V5.78673M6.00034 0.666731L0.880345 0.666731" stroke="#2D343F" stroke-width="0.615385" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                                <div className='flight-popup-details-time'>{formatTime(departureDate)}</div>
                                                            </div>
                                                            <div className='flight-popup-details-date'>{formatDate(departureDate)}</div>
                                                        </div>
                                                        <div className='flight-popup-details-info'>
                                                            <div className='flight-popup-details-info-data'>
                                                                {item.flightTimeInMinutes ? formatDuration(item.flightTimeInMinutes) : 'N/A'}
                                                            </div>
                                                            {/* <div className='flight-popup-details-info-data'>
                                                                1 Stop
                                                            </div> */}
                                                        </div>
                                                        <div className='flight-popup-destination'>
                                                            <div className='flight-popup-details-header'>{item.destination} <span>{item.arrivalTerminal}</span></div>
                                                            <div className='flight-popup-details-time-container'>
                                                                <div className='flight-popup-details-time-icon'>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                                                                        <path d="M0.666523 0.666684L5.99986 6.00002M5.99986 6.00002V0.880017M5.99986 6.00002H0.879856" stroke="#2D343F" stroke-width="0.615385" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                </div>
                                                                <div className='flight-popup-details-time'>{formatTime(arrivalDate)}</div>
                                                            </div>
                                                            <div className='flight-popup-details-date'>{formatDate(arrivalDate)}</div>
                                                        </div>
                                                    </div>
                                                    <div className='flight-popup-airline'>
                                                        {item.operatingCarrierCode && <div><span>Airline:</span> {item.operatingCarrierCode}</div>}
                                                        {item.equipment && <div><span>Equipment:</span> {item.equipment}</div>}
                                                    </div>
                                                </>
                                            );
                                        })
                                    }
                                </div>
                            </div>

                            <div className='flight-popup-content'>
                                <div className='flight-popup-content-title'>Fare Details</div>
                                {
                                    priceRuleData?.map((item, index) => (
                                        <div className='filght-popup-content-details' key={index}>
                                            {item.priceClassName && <div><span>Cabin: </span>{item.priceClassName}</div>}
                                            {item.rbd && <div><span>RBD: </span>{item.rbd}</div>}
                                            {item.priceClassName && <div><span>Price Class: </span>{item.priceClassName} ({item.fareType})</div>}
                                            {item.rulesAndPenalties.length > 0 && <div><span>Rules: </span>{item.rulesAndPenalties}</div>}
                                        </div>
                                    ))
                                }
                            </div>

                            <div className='flight-popup-content'>
                                <div className='flight-popup-content-title'>Baggage Details</div>
                                {
                                    baggageData?.map((item, index) => (
                                        <div className='filght-popup-content-details' key={index}>
                                            {
                                                item.carryOnBaggage && (
                                                    <div className='filght-popup-content-detail'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
                                                            <path d="M4.14307 3.3331H8.85693M4.14307 3.3331C4.14307 2.0451 5.19833 1 6.5 1C7.80167 1 8.85693 2.0444 8.85693 3.3331M4.14307 3.3331C2.40727 3.3331 1 4.7261 1 6.4446V13.9108C1 14.5128 1.704 15 2.57153 15H10.4285C11.2967 15 12 14.5128 12 13.9108V6.4446C12 4.7261 10.5927 3.3331 8.85693 3.3331M5.32153 8H7.67847C8.32967 8 8.85693 7.4778 8.85693 6.8331C8.85693 6.1891 8.32893 5.6669 7.67847 5.6669H5.32153C4.67033 5.6669 4.14307 6.1891 4.14307 6.8331C4.14307 7.4771 4.67107 8 5.32153 8ZM8.85693 15V11.8892C8.85693 11.0296 8.15293 10.3331 7.2854 10.3331H5.71533C4.84707 10.3331 4.1438 11.0296 4.1438 11.8892V15H8.85693Z" stroke="#12234F" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                        <div>
                                                            <span>Carry on Baggage: </span>{item.carryOnBaggage}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            {
                                                item.checkInBaggage && (
                                                    <div className='filght-popup-content-detail'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 14 17" fill="none">
                                                            <g clip-path="url(#clip0_2827_440)">
                                                                <path d="M1.08895 13.0458C1.23752 14.0492 2.09695 14.7761 3.10724 14.8606C4.68438 14.9943 6.32095 15.1418 7.99981 15.1418C9.70267 15.1418 11.353 15.0481 12.9518 14.9006C13.4299 14.8607 13.8807 14.6615 14.2321 14.3349C14.5836 14.0084 14.8153 13.5733 14.8901 13.0995C15.0523 12.0462 15.1367 10.9823 15.1427 9.91663C15.1427 8.81606 15.0535 7.73491 14.8958 6.69377C14.7507 5.73606 13.9564 5.02291 12.9918 4.93263C11.3324 4.77522 9.66663 4.69513 7.99981 4.69263C6.27409 4.69263 4.58838 4.77606 2.97352 4.93034C2.0261 5.02063 1.24438 5.71777 1.10038 6.65834C0.781614 8.77565 0.777763 10.9285 1.08895 13.0469M5.25238 15.0309V4.78634M10.7472 15.0583V4.78634" stroke="#12234F" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M11.2625 4.76926V4.12126C11.2625 3.25589 10.9188 2.42597 10.3069 1.81407C9.69496 1.20216 8.86504 0.858398 7.99967 0.858398C7.13431 0.858398 6.30439 1.20216 5.69249 1.81407C5.08058 2.42597 4.73682 3.25589 4.73682 4.12126V4.76926" stroke="#12234F" stroke-linecap="round" stroke-linejoin="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_2827_440">
                                                                    <rect width="16" height="16" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <div >
                                                            <span>Check in Baggage: </span>{item.checkInBaggage}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        {/* Bundle Slider Section */}
                        {(bundleLoading || bundleData) && (
                            <div className="flight-popup-slider">
                                {bundleLoading ? (
                                    <div className="bundle-loading-container">
                                        <SpinnerLoading />
                                       
                                    </div>
                                ) : bundleData && Object.values(bundleData).length > 0 ? (
                                    <Splide
                                        options={{
                                            perPage: 2,
                                            gap: "1rem",
                                            pagination: false,
                                            arrows: true,
                                            padding: { right: "20%" },
                                            breakpoints: {
                                                650: {
                                                    gap: "10px"
                                                },
                                                576: {
                                                    perPage: 1,
                                                    padding: { right: "15%" },
                                                },
                                            },
                                        }}
                                    >
                                        {Object.values(bundleData).map((card, index) => (
                                            <SplideSlide key={index}>
                                                <FlightPopupCard
                                                    title={card.bundleName}
                                                    price={card?.bundlePrices?.[0]?.totalAmount?.amount}
                                                    selected={selected === card.bundleName}
                                                    onSelect={() => setSelected(card.bundleName)}
                                                    services={card.includedServices}
                                                    currency={card?.bundlePrices?.[0]?.totalAmount?.currencyCode}
                                                />
                                            </SplideSlide>
                                        ))}
                                    </Splide>
                                ) : null}
                            </div>
                        )}

                        <div className='flight-popup-footer'>
                            <div className='flight-popup-footer-info'>
                                <div className='flight-popup-footer-price'>{priceData?.totalAmount?.currency} {priceData?.totalAmount?.amount}</div>
                                <div className='flight-popup-footer-total-price'>Total: {priceData?.totalAmount?.currency} {priceData?.totalAmount?.amount} </div>
                            </div>
                            <div 
                                className='flight-popup-footer-btn'
                                onClick={handleContinue}
                            >
                                continue
                            </div>
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default FlightPopup